export enum UploadFileTypes {
  ReleaseNote = 'ReleaseNote',
  ActivationOrder = 'ActivationOrder',
  ScreenerVideo = 'ScreenerVideo',
  ScreenerImage = 'ScreenerImage',
  MovieTrailer = 'MovieTrailer',
  ScreenerLogo = 'ScreenerLogo',
}
